import {useFormik} from 'formik';
import {useState, useContext, useEffect} from 'react';
import * as Yup from 'yup';
import {AppContext} from '../Context';
import AutoCompletePostalCode from '../../../common-scripts/CustomFields/AutoCompletePostalCode';
import DatePicker from '../../../common-scripts/CustomFields/DatePicker';
import UtilFunctions from "../../../common-scripts/Helpers/Utils";
import ModalComponent from "../../../common-scripts/Helpers/ModalComponent";
import { isValidNumberForRegion } from 'libphonenumber-js';

/**
 * Step Souscription
 *
 * @param texteInfos
 * @param userData
 * @param checkReadyForSaving
 * @returns {JSX.Element}
 * @constructor
 */
const StepSubscribe = ({texteInfos, userData, checkReadyForSaving}) => {

	const {currentStep, dispatchStepEvent, datas, setdatas, referencesUrls} = useContext(AppContext);

	// console.log(parsePhoneNumber('0000000000', 'FR'));
	// console.log(isValidNumberForRegion('1234123412', 'FR'))

	const initialValues = (userData != undefined || userData != null) ? userData : {
		civility: '',
		firstName: '',
		lastName: '',
		birthName: '',
		birthDate: '',
		birthPlace: '',
		email: '',
		phone: '',
		numContrat: '',
		address: '',
		placeOf: '',
		postalCode: '',
		city: '',
	}

	const [designedSubscriberCivility, setdesignedSubscriberCivility] = useState(initialValues.civility == '' ? null : initialValues.civility);

	const phoneRegExp = /^\d{10}$/
	const nameRegExp = /^[a-zA-ZÀ-ÿ]+(?:[ \-][a-zA-ZÀ-ÿ]+)*$/;

	const validationSchema = Yup.object({
		civility: Yup.string().required('Merci de renseigner la civilité'),
		firstName: Yup.string().required('Merci de renseigner le prénom')
			.matches(
				nameRegExp,
				'Le nom entré est invalide'
			),
		lastName: Yup.string().required('Merci de renseigner le nom').matches(
			nameRegExp,
			'Le nom entré est invalide'
		),
		birthName: Yup.string().matches(
			nameRegExp,
			'Le nom entré est invalide'
		),
		birthDate: Yup.date().required('Merci de renseigner la date de naissance '),
		birthPlace: Yup.string().matches(
			nameRegExp,
			'Le lieu de naissance ne peut contenir que des caractères alphabétiques.'
		)
			.required('Merci de renseigner le lieu de naissance '),
		email: Yup.string().required('Merci de renseigner l\'email ').matches(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/, 'Veuillez entrer une adresse email valide'),
		phone: Yup.string().matches(phoneRegExp, 'Format saisi invalide : votre numéro de téléphone doit contenir 10 chiffres.').required('Merci de renseigner le téléphone')
		.test({
			name: 'is-valid-fr-phone',
			test: value => value && isValidNumberForRegion(value.toString(), 'FR'),
			message: 'Le numéro de téléphone n\'est pas valide'
		}),
		numContrat: Yup.number().positive('Le numéro de contrat non valide'),
		address: Yup.string().required("Merci de renseigner l'adresse"),
		placeOf: Yup.string(),
		postalCode: Yup.string().required('Merci de renseigner le code postal'),
		city: Yup.string().required('Merci de renseigner la ville'),

	});

	const formik = useFormik({
		validationSchema: validationSchema,
		initialValues: initialValues
	})

	/**
	 * On postal Change
	 *
	 * @param referentiels
	 * @param cityName
	 * @param postalCodeName
	 */
	const onPostalCodeChange = (referentiels, cityName, postalCodeName) => {

		formik.setFieldValue(postalCodeName, referentiels.postal_code);
		formik.setFieldValue(cityName, referentiels.city_name);
		formik.setTouched({...formik.touched, [postalCodeName]: true, [cityName]: true});

	}

	/**
	 * Validate Step Form, enable or disable save button and next_step button
	 */
	const valideStepForm = () => {
		checkReadyForSaving(Object.keys(formik.touched).length > 0)
		formik.validateForm().then((res) => {
			datas[currentStep] = formik.values;
			setdatas(datas);
			if (Object.keys(res).length == 0) {
				dispatchStepEvent('SET_STEP_READY', true);
			} else {
				dispatchStepEvent('SET_STEP_READY', false)
			}
		})
	}

	useEffect(() => {
		valideStepForm();
	}, [formik.values])

	/**
	 * Civility change
	 *
	 * @param e
	 */
	const onChangeSubscriberCivility = (e) => {

		setdesignedSubscriberCivility(e.target.value);
		formik.setFieldValue('civility', e.target.value);
		formik.setTouched({...formik.touched, 'civility': true})

	}

	// Age filled is accepted or not ( > 18 years)
	const [ acceptedAge, setAcceptedAge ] = useState(true);

	return <>

		{/* Show Popup if age < 18 years */}
		<ModalComponent
			showModal={!acceptedAge}
			content={
				<div className={"form-card"}>
					<p>Vous devez avoir 18 ans au jour de l'adhésion au service de dépôt et gestions des volontés</p>
					<button
						className={"bouton bouton-full bouton-business"}
						type={"button"}
						onClick={() => {

							formik.setFieldValue('birthDate', '');

							setAcceptedAge(true);

						}}
					>
						OK
					</button>
				</div>
			}
		/>


		<div id="step-1" className="step-form">

			<div className="card-banner info" dangerouslySetInnerHTML={{__html: texteInfos}}>

			</div>
			<form>
				<div className="form-card">
					<div className="card-header">
						Je soussigné(e) :
					</div>
					<div className="card-body">

						<div className="form-group block ">
							<label className="control-label" htmlFor="civility">Civilité :</label>
							<div className="container-input">
								<div role="group" className="btn-group btn-group-radio">
									<label className="bouton-form-radio">
										<input
											readOnly={true} defaultValue={'Madame'}
											checked={designedSubscriberCivility === "Madame"}
											onChange={onChangeSubscriberCivility}
											name="civility" type="radio" title="Civilité"/>
										Madame
									</label>

									<label className="bouton-form-radio">
										<input

											readOnly={true} defaultValue={'Monsieur'}
											checked={designedSubscriberCivility === "Monsieur"}
											onChange={onChangeSubscriberCivility}
											name="civility" type="radio" title="Civilité"/>
										Monsieur
									</label>
								</div>
							</div>
						</div>

						<input hidden={true} onChange={formik.handleChange}
							   onBlur={formik.handleBlur} value={formik.values.civility} name="civility" id="civility"/>

						<div className="form-group block ">
							<label className="control-label" htmlFor="firstName">Prénom :</label>
							<div className="container-input">
								<input className="form-control"
									   onChange={formik.handleChange}
									   onBlur={formik.handleBlur}
									   value={formik.values.firstName}
									   name="firstName" type="text" placeholder="Saisissez votre prénom"
									   title="Saisissez votre prénom"/>

								{formik.errors.firstName && formik.touched.firstName ?
									<span className='msg-error'>{formik.errors.firstName}</span> : null}

							</div>
						</div>
						<div className="form-group block ">
							<label className="control-label" htmlFor="lastName">Nom :</label>
							<div className="container-input">
								<input
									className="form-control"
									onChange={formik.handleChange}
									onBlur={formik.handleBlur}
									value={formik.values.lastName}
									name="lastName" type="text" placeholder="Saisissez votre nom civile"
									title="Saisissez votre nom civile"/>
								{formik.errors.lastName && formik.touched.lastName ?
									<span className='msg-error'>{formik.errors.lastName}</span> : null}
							</div>
						</div>
						<div className="form-group block ">
							<label className="control-label" htmlFor="birthName">Nom de naissance (facultatif) : </label>
							<div className="container-input">
								<input
									className="form-control"
									onChange={formik.handleChange}
									onBlur={formik.handleBlur}

									value={formik.values.birthName}
									name="birthName" type="text" placeholder="Saisissez votre nom de naissance"
									title="Saisissez votre nom de naissance"/>

								{formik.errors.birthName && formik.touched.birthName ?
									<span className='msg-error'>{formik.errors.birthName}</span> : null}
							</div>
						</div>
						<div className="form-group block ">
							<label className="control-label" htmlFor="birthDate">Date de naissance :
							</label>
							<div className="container-input">
								<DatePicker
									className={`form-control ${formik.errors.birthDate && formik.touched.birthDate && 'error'}`}
									onChange={formik.handleChange}
									onBlur={formik.handleBlur}
									handleBlur={() => {
										if (formik.values.birthDate !== '') {

											setAcceptedAge(UtilFunctions.checkAcceptedAge(formik.values.birthDate, 18));

										}

										formik.setFieldTouched('birthDate', true);
									}}
									value={formik.values.birthDate}
									name="birthDate"
									title="Date de naissance"
								/>

								{formik.errors.birthDate && formik.touched.birthDate ?
									<span className='msg-error'>{formik.errors.birthDate}</span> : null}
							</div>
						</div>
						<div className="form-group block ">
							<label className="control-label" htmlFor="birthPlace">Lieu de naissance :
							</label>
							<div className="container-input">
								<input className="form-control"
									   onChange={formik.handleChange}
									   onBlur={formik.handleBlur}
									   value={formik.values.birthPlace}
									   name="birthPlace" type="text" placeholder="Saisissez votre lieu de naissance"
									   title="Saisissez votre lieu de naissance"/>
								{formik.errors.birthPlace && formik.touched.birthPlace ?
									<span className='msg-error'>{formik.errors.birthPlace}</span> : null}
							</div>
						</div>
						<div className="form-group block ">
							<label className="control-label" htmlFor="email">E-mail : </label>
							<div className="container-input">
								<input className="form-control"
									   onChange={formik.handleChange}
									   onBlur={formik.handleBlur}
									   value={formik.values.email}

									   name="email" type="email" placeholder="Saisissez votre email"
									   title="Saisissez votre email"/>
								{formik.errors.email && formik.touched.email ?
									<span className='msg-error'>{"Merci de renseigner un email valide"}</span> : null}
							</div>
						</div>
						<div className="form-group block ">
							<label className="control-label" htmlFor="phone">Téléphone : </label>
							<div className="container-input">
								<input
									className="form-control"
									onChange={formik.handleChange}
									onBlur={formik.handleBlur}
									value={formik.values.phone}
									name="phone"
									type="tel"
									title="Saisissez votre email"
								/>
								{formik.errors.phone && formik.touched.phone ?
									<span className='msg-error'>{formik.errors.phone}</span> : null}
							</div>
						</div>
						<div className="form-group block ">
							<label className="control-label" htmlFor="numContrat">Numéro de contrat (facultatif) : </label>
							<div className="container-input">
								<input
									className="form-control"
									onChange={formik.handleChange}
									onBlur={formik.handleBlur}
									value={formik.values.numContrat}
									name="numContrat"
									type="number"
									onKeyDown={UtilFunctions.preventNumericSymbols}
									placeholder="Saisissez votre numéro de contrat"
									title="Saisissez votre numéro de contrat"
								/>
								{formik.errors.numContrat && formik.touched.numContrat ?
									<span className='msg-error'>{formik.errors.numContrat}</span> : null}
							</div>
						</div>

					</div>
				</div>

				<div className="form-card">
					<div className="card-header">
						Adresse :
					</div>
					<div className="card-body">
						<div className="form-group block ">
							<label className="control-label" htmlFor="placeOf">Adresse : </label>
							<div className="container-input">
								<input
									className="form-control"
								   	onChange={formik.handleChange}
								   	onBlur={formik.handleBlur}
								   	value={formik.values.address}
									name="address"
									type="text"
									placeholder="Saisissez l'adresse "
									title="Adresse "
								/>
								{formik.errors.address && formik.touched.address ?
									<span className='msg-error'>{formik.errors.address}</span> : null}
							</div>
						</div>

						<div className="form-group block ">
							<label className="control-label" htmlFor="placeOf">Lieu-dit (facultatif) : </label>
							<div className="container-input">
								<input className="form-control"
									   onChange={formik.handleChange}
									   onBlur={formik.handleBlur}
									   value={formik.values.placeOf}
									   name="placeOf" type="text" placeholder="Saisissez Lieu-dit " title="Lieu-dit "/>
								{formik.errors.placeOf && formik.touched.placeOf ?
									<span className='msg-error'>{formik.errors.placeOf}</span> : null}
							</div>
						</div>

						<div className="form-group block ">
							<label className="control-label" htmlFor="postalCode">Code postal : </label>
							<div className="container-input">
								<AutoCompletePostalCode oldValue={formik.values.postalCode}
														onPostalCodeChange={onPostalCodeChange} cityName="city"
														postalCodeName="postalCode"
														refUrl={referencesUrls.referentiel}/>
								{formik.errors.postalCode && formik.touched.postalCode ?
									<span className='msg-error'>{formik.errors.postalCode}</span> : null}
							</div>
						</div>
						<input hidden={true} onChange={formik.handleChange}
							   onBlur={formik.handleBlur} value={formik.values.postalCode} name="postalCode"
							   id="postalCode"/>
						<div className="form-group block ">
							<label className="control-label" htmlFor="city">Ville : </label>
							<div className="container-input">
								<input className="form-control"
									   onChange={formik.handleChange}
									   onBlur={formik.handleBlur}
									   value={formik.values.city}
									   name="city" type="text" placeholder="Saisissez votre ville "
									   title="Saisissez votre ville "/>
								{formik.errors.city && formik.touched.city ?
									<span className='msg-error'>{formik.errors.city}</span> : null}
							</div>
						</div>


					</div>
				</div>

			</form>


		</div>
	</>;
};

export default StepSubscribe;
